export default __webpack_public_path__ + "static/media/0_upper_right.feab294a.svg";